import { ApiService } from 'src/services/core';
import VwGnlKurumTarife from 'src/models/Settings/Generals/VwGnlKurumTarifeDTO';

class VwGnlKurumTarifeService extends ApiService<VwGnlKurumTarife> {
  constructor() {
    super('VwGnlKurumTarifeDTO');
  }
  getBySozlesmeNo = (sozlesmeNo: string, organizasyonId: number) => {
    return this.find({
      filters: {
        groupOperator: "and",
        predicates: [
          { fieldName: "sozlesmeNo", operator: "like", value1: sozlesmeNo },
          { fieldName: "fkGnlOrganizasyonId", operator: "=", value1: organizasyonId }
        ]
      }
    })
  }
}
export default new VwGnlKurumTarifeService();
